/**
 * Free text a person typed, tidied for display.
 *
 * Everywhere this app shows what somebody wrote - a repair description, a request's
 * justification, a note on an employee - it renders with `pre-wrap`, because the
 * paragraphs they typed are how the report reads. That also renders faithfully the
 * things a paste out of a mail client leaves behind: runs of spaces holding words
 * apart, trailing spaces, and a wall of blank lines that pushes the rest of the card
 * off the screen. The first repair request raised against a keyboard that was typing
 * on its own arrived looking corrupted for exactly this reason.
 *
 * Paragraph breaks survive, because they carry meaning. Runs of whitespace do not.
 *
 * Display only. Nothing here rewrites what is stored - the record keeps the words as
 * they were typed, and a second opinion about what somebody meant is not this
 * function's to have.
 */
export function tidyText(text: string): string {
  return text
    .replace(/[^\S\n]+/g, ' ')
    .replace(/ *\n */g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
